export type EmployeeCertificationElem = {
    EmployeeCertificationId: number
    EmployeeId: number
    CertificationId: number
    CertificationName: string
    ExpirationType: number
    ExpirationDate: string | null
    WrittenTestDate: string | null
    HasBadge: boolean | null
    BadgeIssueDate: string | null
    BadgeRenewalDate: string | null
    CertGroupId: number
    CertGroupName: string
    CertCategoryId: number
    CertCategoryName: string
    CertSubcategoryId: number | null
    CertSubcategoryName: string | null
    EmployeeCertificationStatusTypeId: number | null
    CreatedDate: string | null
    CreatedBy: string | null
}

// Model sent to POST api/user/CreateOrUpdateEmployeeCertificationPost
export type EmployeeCertificationSaveModel = {
    EmployeeCertificationId: number
    EmployeeId: number
    CertificationId: number
    EmployeeCertificationStatusTypeId: number | null
    WrittenTestDate: string | null
    HasBadge: boolean | null
    BadgeIssueDate: string | null
    BadgeRenewalDate: string | null
}

// Status type IDs matching EmployeeCertificationStatusTypeId in the database
// Default for new training certs is NO (2)
export const CERT_STATUS = {
    YES: 1,
    NO: 2,
    NA: 3,
} as const

export type CertStatusValue = typeof CERT_STATUS[keyof typeof CERT_STATUS]
